import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store, persistor } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Navigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import GraciousTestimonial from "../components/Frontend/GraciousTestimonial";
import Slider from "react-slick";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";


class NaatiAppLp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      error: [],
      submit: false,
      flag: false,
      lockSubmit: false,
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
    this.validator = new SimpleReactValidator();
    this.sliderRef = React.createRef();
  }
  componentDidMount() {
    this.adjustSliderWidth();
    window.addEventListener("resize", this.adjustSliderWidth);
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.adjustSliderWidth);
  }
  adjustSliderWidth = () => {
    const container = document.querySelector(".container");
    const outerDiv = document.querySelector(".outer-wrapper");
    const slickList = document.querySelector(".slick-list");
    if (container && outerDiv && slickList) {
      const leftWidth = container.getBoundingClientRect().left;
      const rightWidth =
        outerDiv.getBoundingClientRect().right - window.innerWidth;
      this.setState({
        sliderStyles: {
          marginLeft: `${leftWidth}px`,
          width: `calc(100vw - ${leftWidth}px + ${Math.abs(rightWidth)}px)`,
        },
      });
    }
  };
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  submitForm = () => {
    if (this.validator.allValid() && !this.state.lockSubmit) {
      this.setState({ lockSubmit: true });
      let json = {
        name: this.state.name,
        email: this.state.email,
        phone: this.state.phone,
        message: this.state.message,
      };
      API({
        method: "POST",
        url: "post/contact",
        data: json,
      })
        .then((data) => {
          this.setState({
            submit: true,
            lockSubmit: false,
            name: "",
            email: "",
            phone: "",
            message: "",
            flag: true,
          });

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          this.setState({ lockSubmit: false });
        });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  render() {
    if (this.state.flag) {
      return <Navigate to="/thank-you" replace />;
    }
    const pteSlider = {
      dots: true,
      arrows: true,
      // infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>Language Academy</title>
          <meta name="twitter:title" content="Language Academy" />
          <meta property="og:title" content="Language Academy" />
        </Helmet>
        <Header />

        <div className="banner-section noc-banner">
          <div className="container">
            <div className="row">
              <div className="banner-content">
                <div className="banner-inner-content">
                  <h1 className="primary-heading dark-blue-color">
                    <span className="fw-700">
                      MASTER NAATI CCL & PTE FROM <br className="d-none d-md-block" /> ANYWHERE
                    </span><br className="d-block d-md-none" /> <span className="light-red-text light-blue-text">
                      AUSTRALIA'S
                    </span><br className="d-block d-md-none" /> MOST <br className="d-none d-md-block" /> COMPREHENSIVE LANGUAGE EXAM APPS
                  </h1>
                  <p className="sub-title">
                    The complete mobile solution that ensures your language
                    proficiency goals <br className="d-none d-md-block" /> are
                    always within reach, wherever life takes you.
                  </p>
                </div>
                <div className="iframe-video-outer position-relative">
                  <div className="banner-img-wrapper">
                    <img
                      className="banner-img"
                      src="/images/web-new-images/banners/naati-app-lp-banner.png"
                      alt="LA"
                    />
                  </div>
                  <img
                    className="emoji1 position-absolute"
                    src="/images/web-new-images/emojis/emoji-1.png"
                    alt="LA"
                  />
                  <img
                    className="emoji2 position-absolute"
                    src="/images/web-new-images/emojis/emoji-2.png"
                    alt="LA"
                  />
                  <img
                    className="emoji3 position-absolute"
                    src="/images/web-new-images/emojis/emoji-3.png"
                    alt="LA"
                  />
                  <img
                    className="emoji4 position-absolute"
                    src="/images/web-new-images/emojis/emoji-4.png"
                    alt="LA"
                  />
                </div>
                <div className="light-blue-box">
                  Achieve your Australian permanent residency dreams and global
                  opportunities with our powerful mobile apps, designed
                  specifically for busy professionals, students, and immigrants
                  who need flexible, expert-level preparation for both NAATI CCL
                  and PTE exams.
                </div>
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    DOWNLOAD OUR APPS TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-ccl-exam na-la-apps">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  HOW
                  <br />
                  <span className="wpl-badge pte-naati-badge text-white">
                    LANGUAGE <br className="d-block d-md-none" /> ACADEMY APPS
                  </span>
                  <br className="d-block" />
                  INCREASE YOUR CHANCES <br className="d-none d-md-block" /> FOR
                  SUCCESS
                </h2>
              </div>
              <div className="col-lg-6">
                <div className="ccl-exam-img">
                  <img
                    src="/images/web-new-images/naati-app-img.png"
                    alt="Image"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <p>
                  Missing classes due to work commitments? Stuck in traffic
                  during your commute? Have a few spare minutes between
                  meetings?
                </p>
                <p className="sub-title fw-600">
                  Your NAATI CCL and PTE preparation never has to stop.
                </p>
                <div className="light-blue-box my-4">
                  Our mobile apps deliver the same expert-level training that
                  has helped 50,000+ students achieve their goals, now optimized
                  for your smartphone and available 24/7.
                </div>
                <p className="sub-title fw-400">
                  The apps that turn dead time into exam success.
                </p>
                <Link className="primary-btn mt-4" to="/auth/register">
                  <span className="btn-inner">
                    START YOUR MOBILE MASTERY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="pc-why-choose np-need-crack">
          <div className="container">
            <div className="row why-most-second-row">
              <div className="col-lg-6 why-most-content">
                <h2 className="primary-heading fw-700">
                  EVERYTHING YOU
                  <br />
                  NEED TO CRACK
                  <br />
                  <span className="wpl-badge text-white">NAATI CCL & PTE</span>
                  <br />
                  IN YOUR POCKET
                </h2>
                <div className="text-center text-md-start">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    EXPERIENCE THE FULL POWER OF MOBILE LEARNING
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="why-most-list">
                  <ul>
                    <li className="list1">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24.641 6.50121C26.4048 8.95306 27.4436 11.9614 27.4436 15.2123C27.4436 18.4633 26.4048 21.4716 24.641 23.9234M19.66 10.2345C20.6442 11.6455 21.2214 13.3615 21.2214 15.2123C21.2214 17.0631 20.6442 18.7791 19.66 20.1901M12.0552 6.95629L8.11565 10.8958C7.90042 11.111 7.79281 11.2186 7.66722 11.2956C7.55588 11.3638 7.43449 11.4141 7.30751 11.4446C7.16429 11.479 7.0121 11.479 6.70772 11.479H4.5458C3.84884 11.479 3.50037 11.479 3.23417 11.6146C3.00001 11.7339 2.80963 11.9243 2.69032 12.1585C2.55469 12.4247 2.55469 12.7731 2.55469 13.4701V16.9545C2.55469 17.6515 2.55469 18 2.69032 18.2662C2.80963 18.5003 3.00001 18.6907 3.23417 18.81C3.50037 18.9457 3.84884 18.9457 4.5458 18.9457H6.70772C7.0121 18.9457 7.16429 18.9457 7.30751 18.98C7.43449 19.0105 7.55588 19.0608 7.66722 19.129C7.79281 19.206 7.90042 19.3136 8.11565 19.5288L12.0552 23.4684C12.5883 24.0015 12.8548 24.268 13.0836 24.286C13.2822 24.3016 13.4763 24.2213 13.6056 24.0698C13.7547 23.8953 13.7547 23.5183 13.7547 22.7644V7.66025C13.7547 6.90635 13.7547 6.52939 13.6056 6.35484C13.4763 6.20339 13.2822 6.12301 13.0836 6.13864C12.8548 6.15665 12.5883 6.4232 12.0552 6.95629Z"
                            stroke="#7F56D9"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">
                          NAATI CCL COMPREHENSIVE VOCABULARY MASTERY
                        </h3>
                        <h4 className="sub-sub-title my-4">
                          2,000+ Essential Words{" "}
                          <br className="d-none d-md-block" /> in 7 Strategic
                          Categories
                        </h4>
                        <ul className="circle-list">
                          <li>
                            Complete vocabulary lists translated into all 10
                            supported languages
                          </li>
                          <li>
                            Context-based learning with real exam scenarios
                          </li>
                          <li>
                            Cultural nuances and terminology specific to NAATI
                            CCL requirements
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="list2">
                      <span className="list-counting">
                        <svg
                          width="28"
                          height="25"
                          viewBox="0 0 28 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.2436 5.99047L13.8553 3.21401C13.4558 2.41494 13.256 2.01538 12.958 1.72348C12.6944 1.46534 12.3768 1.26902 12.028 1.14873C11.6336 1.0127 11.1869 1.0127 10.2935 1.0127H5.53691C4.143 1.0127 3.44605 1.0127 2.91364 1.28397C2.44533 1.52259 2.06458 1.90334 1.82596 2.37165C1.55469 2.90406 1.55469 3.60101 1.55469 4.99492V5.99047M1.55469 5.99047H20.4702C22.5611 5.99047 23.6065 5.99047 24.4051 6.39738C25.1076 6.75531 25.6787 7.32644 26.0367 8.02891C26.4436 8.82751 26.4436 9.87294 26.4436 11.9638V17.4394C26.4436 19.5302 26.4436 20.5757 26.0367 21.3743C25.6787 22.0767 25.1076 22.6479 24.4051 23.0058C23.6065 23.4127 22.5611 23.4127 20.4702 23.4127H7.52802C5.43716 23.4127 4.39173 23.4127 3.59312 23.0058C2.89065 22.6479 2.31952 22.0767 1.9616 21.3743C1.55469 20.5757 1.55469 19.5302 1.55469 17.4394V5.99047ZM11.3237 11.9044C11.543 11.2811 11.9758 10.7555 12.5454 10.4207C13.1151 10.0859 13.7848 9.96349 14.4361 10.0752C15.0873 10.1869 15.678 10.5255 16.1035 11.031C16.5291 11.5365 16.762 12.1763 16.761 12.837C16.761 14.7023 13.9631 15.6349 13.9631 15.6349M13.9991 19.3683H14.0116"
                            stroke="#0286FF"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">PTE COMPLETE QUESTION BANK</h3>
                        <h4 className="sub-sub-title my-4">
                          8,000+ Practice Questions{" "}
                          <br className="d-none d-md-block" /> Covering All Exam
                          Modules
                        </h4>
                        <ul className="circle-list">
                          <li>
                            All 20+ PTE question types with detailed
                            explanations
                          </li>
                          <li>
                            Algorithm-based scoring that mirrors the real exam
                          </li>
                          <li>
                            Updated templates designed to trigger maximum points
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="list3">
                      <span className="list-counting">
                        <svg
                          width="28"
                          height="25"
                          viewBox="0 0 28 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.9991 24.0182L13.8746 23.8314C13.0102 22.5347 12.578 21.8864 12.0069 21.417C11.5014 21.0015 10.9188 20.6898 10.2927 20.4996C9.5854 20.2848 8.8062 20.2848 7.2478 20.2848H5.53691C4.143 20.2848 3.44605 20.2848 2.91364 20.0136C2.44533 19.7749 2.06458 19.3942 1.82596 18.9259C1.55469 18.3935 1.55469 17.6965 1.55469 16.3026V5.60039C1.55469 4.20648 1.55469 3.50952 1.82596 2.97712C2.06458 2.50881 2.44533 2.12805 2.91364 1.88944C3.44605 1.61816 4.143 1.61816 5.53691 1.61816H6.03469C8.82251 1.61816 10.2164 1.61816 11.2812 2.16071C12.2178 2.63795 12.9794 3.39945 13.4566 4.33608C13.9991 5.40088 13.9991 6.79479 13.9991 9.58261M13.9991 24.0182V9.58261M13.9991 24.0182L14.1236 23.8314C14.9881 22.5347 15.4203 21.8864 15.9914 21.417C16.4969 21.0015 17.0794 20.6898 17.7056 20.4996C18.4129 20.2848 19.1921 20.2848 20.7505 20.2848H22.4614C23.8553 20.2848 24.5522 20.2848 25.0846 20.0136C25.5529 19.7749 25.9337 19.3942 26.1723 18.9259C26.4436 18.3935 26.4436 17.6965 26.4436 16.3026V5.60039C26.4436 4.20648 26.4436 3.50952 26.1723 2.97712C25.9337 2.50881 25.5529 2.12805 25.0846 1.88944C24.5522 1.61816 23.8553 1.61816 22.4614 1.61816H21.9636C19.1758 1.61816 17.7819 1.61816 16.717 2.16071C15.7804 2.63795 15.0189 3.39945 14.5417 4.33608C13.9991 5.40088 13.9991 6.79479 13.9991 9.58261"
                            stroke="#94C23C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">
                          REALISTIC PRACTICE{" "}
                          <br className="d-none d-md-block" /> DIALOGUES & AUDIO
                        </h3>
                        <h4 className="sub-sub-title my-4">
                          <span className="fw-800">NAATI CCL</span> 80+
                          Expert-Crafted Dialogue Sessions
                        </h4>
                        <ul className="circle-list">
                          <li>
                            Practice scenarios inspired by previous actual exams
                          </li>
                          <li>
                            Sample responses prepared by certified NAATI
                            interpreters
                          </li>
                          <li>
                            Varied difficulty levels to match your preparation
                            stage
                          </li>
                        </ul>
                        <h4 className="sub-sub-title my-4">
                          <span className="fw-800">PTE</span> Comprehensive
                          Listening Practice
                        </h4>
                        <ul className="circle-list">
                          <li>
                            Authentic accent training with varied speaking
                            speeds
                          </li>
                          <li>Real exam-style audio content</li>
                          <li>Integrated scoring across all sections</li>
                        </ul>
                      </div>
                    </li>
                    <li className="list4">
                      <span className="list-counting">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.9991 6.74633V14.213L18.9769 16.7019M26.4436 14.213C26.4436 21.0859 20.872 26.6574 13.9991 26.6574C7.12626 26.6574 1.55469 21.0859 1.55469 14.213C1.55469 7.34012 7.12626 1.76855 13.9991 1.76855C20.872 1.76855 26.4436 7.34012 26.4436 14.213Z"
                            stroke="#FFB02C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">REAL-TIME EXAM SIMULATION</h3>
                        <h4 className="sub-sub-title my-4">
                          Mock Tests That Mirror the Actual Experience
                        </h4>
                        <h4 className="sub-sub-title my-4 fw-800">NAATI CCL</h4>
                        <ul className="circle-list">
                          <li>
                            30-minute timed practice sessions just like the real
                            exam
                          </li>
                          <li>
                            Two 300-word dialogues with authentic audio quality
                          </li>
                          <li>
                            Instant scoring and detailed performance analysis
                          </li>
                        </ul>
                        <h4 className="sub-sub-title my-4 fw-800">PTE</h4>
                        <ul className="circle-list">
                          <li>
                            Full-length scored mock tests with precise feedback
                          </li>
                          <li>
                            AI-powered assessment matching real exam algorithms
                          </li>
                          <li>Comprehensive performance analytics</li>
                        </ul>
                      </div>
                    </li>
                    <li className="list5">
                      <span className="list-counting">
                        <svg
                          width="27"
                          height="27"
                          viewBox="0 0 27 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.2445 11.9672L3.4223 23.7895M16.5119 2.68176C18.0276 3.68753 19.4845 4.87327 20.846 6.23468C22.2191 7.60783 23.4135 9.07813 24.4249 10.608M10.584 8.10465L7.00641 6.91211C6.5944 6.77477 6.14059 6.86216 5.80904 7.1427L2.25347 10.1513C1.52556 10.7672 1.73236 11.9393 2.6271 12.269L5.99605 13.5102M13.6032 21.117L14.8443 24.486C15.174 25.3807 16.3461 25.5875 16.9621 24.8596L19.9706 21.304C20.2512 20.9725 20.3386 20.5187 20.2012 20.1067L19.0087 16.5291M23.145 1.10413L17.0391 2.12177C16.3798 2.23165 15.7751 2.55571 15.3185 3.04383L7.08888 11.841C4.95571 14.1213 5.01504 17.6823 7.223 19.8903C9.43096 22.0983 12.992 22.1576 15.2723 20.0244L24.0695 11.7948C24.5576 11.3382 24.8817 10.7335 24.9915 10.0742L26.0092 3.96832C26.2899 2.28379 24.8295 0.823373 23.145 1.10413Z"
                            stroke="#94C23C"
                            strokeOpacity="0.98"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">PROVEN SUCCESS STRATEGIES</h3>
                        <h4 className="sub-sub-title my-4">
                          Expert Tips for First-Attempt Success
                        </h4>
                        <h4 className="sub-sub-title my-4 fw-800">NAATI CCL</h4>
                        <ul className="circle-list">
                          <li>Time management techniques under pressure</li>
                          <li>
                            Cultural sensitivity training for accurate
                            interpretation
                          </li>
                          <li>
                            Last-minute preparation packages for exam day
                            confidence
                          </li>
                        </ul>
                        <h4 className="sub-sub-title my-4 fw-800">PTE</h4>
                        <ul className="circle-list">
                          <li>Updated templates for all question types</li>
                          <li>
                            Section-specific strategies for maximum scores
                          </li>
                          <li>
                            Real-time feedback on speaking and writing tasks
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="list1">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.7335 2.76855V4.51078C18.7335 5.20773 18.7335 5.55621 18.5979 5.82241C18.4786 6.05657 18.2882 6.24694 18.054 6.36625C17.7878 6.50189 17.4394 6.50189 16.7424 6.50189H13.258C12.561 6.50189 12.2125 6.50189 11.9463 6.36625C11.7122 6.24694 11.5218 6.05657 11.4025 5.82241C11.2668 5.55621 11.2668 5.20773 11.2668 4.51078V2.76855M10.2713 27.6574H19.7291C21.123 27.6574 21.8199 27.6574 22.3523 27.3862C22.8206 27.1476 23.2014 26.7668 23.44 26.2985C23.7113 25.7661 23.7113 25.0691 23.7113 23.6752V6.75078C23.7113 5.35687 23.7113 4.65991 23.44 4.12751C23.2014 3.6592 22.8206 3.27845 22.3523 3.03983C21.8199 2.76855 21.123 2.76855 19.7291 2.76855H10.2713C8.87738 2.76855 8.18042 2.76855 7.64802 3.03983C7.17971 3.27845 6.79895 3.6592 6.56034 4.12751C6.28906 4.65991 6.28906 5.35687 6.28906 6.75078V23.6752C6.28906 25.0691 6.28906 25.7661 6.56034 26.2985C6.79895 26.7668 7.17971 27.1476 7.64802 27.3862C8.18042 27.6574 8.87738 27.6574 10.2713 27.6574Z"
                            stroke="#7F56D9"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3 className="fw-600">SEAMLESS MOBILE EXPERIENCE</h3>
                        <h4 className="sub-sub-title my-4">
                          Study Anywhere, Anytime with Zero Compromise
                        </h4>
                        <ul className="circle-list">
                          <li>
                            Offline access to all vocabulary and practice
                            materials
                          </li>
                          <li>Progress tracking across all devices</li>
                          <li>Never miss a learning opportunity again</li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="why-choosing-section np-busy-lifestyle">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center text-white fw-700">
                DESIGNED FOR
                <br />
                <span className="wpl-badge gold-badge text-white">
                  YOUR BUSY LIFESTYLE
                </span>
              </h2>
              <div className="feature-cards four-cards d-none d-md-grid">
                <div className="feature-card card2">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.78906L9 17.7891L4 12.7891"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    PERFECT <br /> FOR COMMUTERS
                  </h3>
                  <p className="fw-300">
                    Transform your daily travel time into productive exam
                    preparation. Practice NAATI CCL vocabulary or PTE speaking
                    tasks during train rides, or review dialogues and templates
                    while waiting.
                  </p>
                </div>
                <div className="feature-card card3">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.78906L9 17.7891L4 12.7891"
                          stroke="#0286FF"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    IDEAL FOR WORKING <br /> PROFESSIONALS
                  </h3>
                  <p>
                    Squeeze in focused practice sessions during lunch breaks,
                    before meetings, or whenever you have 10-15 spare minutes.
                    Switch between NAATI CCL and PTE preparation based on your
                    priorities.
                  </p>
                </div>
                <div className="feature-card card1">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.78906L9 17.7891L4 12.7891"
                          stroke="#7F56D9"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    ESSENTIAL <br /> FOR STUDENTS
                  </h3>
                  <p>
                    Balance your exam preparation with university commitments.
                    Study efficiently for both NAATI CCL and PTE without
                    compromising your academic schedule.
                  </p>
                </div>
                <div className="feature-card card4">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.78906L9 17.7891L4 12.7891"
                          stroke="#FFB02C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    COMPLEMENT TO <br /> CLASSROOM LEARNING
                  </h3>
                  <p>
                    Never fall behind even if you miss in-person classes. Access
                    the same quality materials and exercises for both exams from
                    anywhere.
                  </p>
                </div>
              </div>

              {/* Mobile HTML */}
              <div className="slider-dot-arrow d-block d-md-none mobile-slider transparent-arrows">
                <Slider {...CardsSlider} className="feature-cards four-cards">
                  <div className="feature-card card2">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.78906L9 17.7891L4 12.7891"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>
                      PERFECT <br /> FOR COMMUTERS
                    </h3>
                    <p className="fw-300">
                      Transform your daily travel time into productive exam
                      preparation. Practice NAATI CCL vocabulary or PTE speaking
                      tasks during train rides, or review dialogues and
                      templates while waiting.
                    </p>
                  </div>
                  <div className="feature-card card3">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.78906L9 17.7891L4 12.7891"
                            stroke="#0286FF"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>
                      IDEAL FOR WORKING <br /> PROFESSIONALS
                    </h3>
                    <p>
                      Squeeze in focused practice sessions during lunch breaks,
                      before meetings, or whenever you have 10-15 spare minutes.
                      Switch between NAATI CCL and PTE preparation based on your
                      priorities.
                    </p>
                  </div>
                  <div className="feature-card card1">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.78906L9 17.7891L4 12.7891"
                            stroke="#7F56D9"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>
                      ESSENTIAL <br /> FOR STUDENTS
                    </h3>
                    <p>
                      Balance your exam preparation with university commitments.
                      Study efficiently for both NAATI CCL and PTE without
                      compromising your academic schedule.
                    </p>
                  </div>
                  <div className="feature-card card4">
                    <div className="rounded-circle">
                      <div className="img-wrapper">
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.78906L9 17.7891L4 12.7891"
                            stroke="#FFB02C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <h3>
                      COMPLEMENT TO <br /> CLASSROOM LEARNING
                    </h3>
                    <p>
                      Never fall behind even if you miss in-person classes.
                      Access the same quality materials and exercises for both
                      exams from anywhere.
                    </p>
                  </div>
                </Slider>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p className="sub-title text-white fw-500 text-center text-md-start mb-4 mb-md-0">
                    Your schedule doesn't have to limit your success.
                  </p>
                </div>
                <div className="col-md-6 text-center text-md-end">
                  <Link to="/auth/register" className="primary-btn">
                    EXPERIENCE COMPLETE PTE MASTERY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="master-aspect-section ap-minute-count">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center fw-700">
                THE 5-POINT DIFFERENCE
                <br />
                & GLOBAL OPPORTUNITIES
                <br />
                <span className="wpl-badge pte-naati-badge text-white">
                  WHY EVERY MINUTE COUNTS
                </span>
              </h2>
              <div className="master-cards">
                <div className="master-card">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 18.71V12.71C21 7.7394 16.9706 3.70996 12 3.70996C7.02944 3.70996 3 7.7394 3 12.71V18.71M5.5 21.71C4.11929 21.71 3 20.5907 3 19.21V17.21C3 15.8292 4.11929 14.71 5.5 14.71C6.88071 14.71 8 15.8292 8 17.21V19.21C8 20.5907 6.88071 21.71 5.5 21.71ZM18.5 21.71C17.1193 21.71 16 20.5907 16 19.21V17.21C16 15.8292 17.1193 14.71 18.5 14.71C19.8807 14.71 21 15.8292 21 17.21V19.21C21 20.5907 19.8807 21.71 18.5 21.71Z"
                        stroke="#7F56D9"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title"><span className="fw-800">NAATI CCL</span> <br /> THE STAKES ARE HIGH</h2>
                  <ul>
                    <li>
                      <p><span className="circle"></span> 5 bonus points can move you from "not competitive" to "invitation received"</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Thousands of applications depend on these critical points</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Your Australian dream shouldn't be left to chance</p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card2">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.249 17.71H20.4229M13.249 17.71L11.3359 21.71M13.249 17.71L16.1142 11.719C16.3451 11.2362 16.4606 10.9949 16.6185 10.9186C16.7559 10.8522 16.916 10.8522 17.0534 10.9186C17.2113 10.9949 17.3268 11.2362 17.5576 11.719L20.4229 17.71M20.4229 17.71L22.3359 21.71M2.33594 5.70996H8.33594M8.33594 5.70996H11.8359M8.33594 5.70996V3.70996M11.8359 5.70996H14.3359M11.8359 5.70996C11.3398 8.66725 10.1885 11.3461 8.50149 13.5944M10.3359 14.71C9.72341 14.4348 9.09859 14.052 8.50149 13.5944M8.50149 13.5944C7.14896 12.5577 5.9387 11.1366 5.33594 9.70996M8.50149 13.5944C6.8968 15.7329 4.80737 17.4818 2.33594 18.71"
                        stroke="#94C23C"
                        strokeOpacity="0.98"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">
                    <span className="fw-800">PTE</span> GLOBAL <br /> RECOGNITION
                  </h2>
                  <ul>
                    <li>
                      <p><span className="circle"></span> Accepted by universities and immigration authorities worldwide</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> Fast 24-hour results for urgent applications</p>
                    </li>
                    <li>
                      <p><span className="circle"></span> AI-powered scoring ensures consistent, unbiased evaluation</p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card3">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6641 6.70996V12.71L16.6641 14.71M22.6641 12.71C22.6641 18.2328 18.1869 22.71 12.6641 22.71C7.14121 22.71 2.66406 18.2328 2.66406 12.71C2.66406 7.18711 7.14121 2.70996 12.6641 2.70996C18.1869 2.70996 22.6641 7.18711 22.6641 12.71Z"
                        stroke="#0286FF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">MAXIMIZE YOUR PREPARATION TIME</h2>
                  <ul>
                     <li>
                      <p><span className="circle"></span> Every minute matters when preparing for such important exams</p>
                    </li>
                     <li>
                      <p><span className="circle"></span> Consistent daily practice beats intensive cramming sessions</p>
                    </li>
                     <li>
                      <p><span className="circle"></span> Mobile accessibility means no wasted opportunities</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading fw-600">
                  Don't let a busy schedule cost you your future opportunities.
                </p>
                <Link to="/auth/register" className="primary-btn">
                  SECURE YOUR SUCCESS TODAY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="all-language-section language-support">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center mb-md-0 fw-700">
                Comprehensive
                <br />
                <span className="wpl-badge gold-badge text-white">
                  LANGUAGE SUPPORT
                </span>
              </h2>
            </div>        
            <div className="all-language-content">
              <div className="all-lang-card">
                <h2 className="title">
                  NAATI CCL PREPARATION AVAILABLE IN ALL 10 LANGUAGES
                </h2>
                <ul>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-01.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Hindi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-02.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Tamil</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-03.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Marathi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-04.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Telugu</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-05.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Punjabi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-06.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Urdu</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-07.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Nepali</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-08.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Malayalam</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-09.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Sinhalese</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-10.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Bangla</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-11.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Gujarati</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-12.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Kannada</h3>
                  </li>
                </ul>
              </div>        
              <div className="all-lang-card">
                <h2 className="title">PTE PREPARATION FOR GLOBAL SUCCESS</h2>
                <p>
                  Complete preparation materials for PTE Academic and PTE Core, accepted by institutions and immigration authorities worldwide.
                  <br />
                  <br />
                  Complete vocabulary translations, cultural context, and practice materials in your native language for NAATI CCL, plus comprehensive PTE preparation for international opportunities.
                </p>
              </div>
            </div>        
            <div className="text-center">
              <Link to="/auth/register" className="primary-btn dark-border">
                FIND YOUR PREPARATION PATH
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>

         <div className="sss-section">
          <CrackedCodeSlider title={`<span className="fw-700">WHAT OUR</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">APP USERS SAY</span>`} />
          <div className="container">
            <div className="text-center">              
              <Link to="#" className="primary-btn">
                JOIN THOUSANDS OF SUCCESSFUL APP USERS
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="naati-mobile-app vc-blue-section">
          <div className="container">
            <div className="row mt-0">
              <div className="col-lg-6">
                <h2 className="primary-heading fw-700 mb-0">
                  MORE THAN APPS,
                  <br className="d-none d-md-block" />
                  THEY'RE YOUR
                  <br className="d-block" />
                  <span className="wpl-badge text-white">
                    SUCCESS COMPANIONS
                  </span>
                </h2>
                <p className="sub-title fw-500 my-4 text-center text-md-start">
                  This isn't just practice, it's precision preparation.
                </p>
                <div className="text-center text-md-start">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR PRECISION PREPARATION
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="why-most-list">
                  <ul>
                    <li className="list7">
                      <span className="list-counting">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.55469 17.5546C2.55469 17.5546 2.70566 18.6114 7.07954 22.9853C11.4534 27.3592 18.5449 27.3592 22.9187 22.9853C24.4684 21.4356 25.469 19.5448 25.9206 17.5546M2.55469 17.5546V25.0213M2.55469 17.5546H10.0214M27.4436 12.5768C27.4436 12.5768 27.2926 11.52 22.9187 7.14613C18.5449 2.77225 11.4534 2.77225 7.07954 7.14613C5.52986 8.6958 4.52924 10.5866 4.07767 12.5768M27.4436 12.5768V5.11017M27.4436 12.5768H19.9769" stroke="#FFB02C" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                      <div>
                        <h3>SEAMLESS INTEGRATION</h3>
                        <p>
                          Works perfectly alongside our online classes and in-person coaching. Your progress syncs across all platforms for both NAATI CCL and PTE preparation.
                        </p>
                      </div>
                    </li>
                    <li className="list3">
                      <span className="list-counting">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.9991 26.2657L14.8746 26.079C14.0102 24.7823 13.578 24.134 13.0069 23.6646C12.5014 23.2491 11.9188 22.9373 11.2927 22.7472C10.5854 22.5324 9.8062 22.5324 8.2478 22.5324H6.53691C5.143 22.5324 4.44605 22.5324 3.91364 22.2611C3.44533 22.0225 3.06458 21.6417 2.82596 21.1734C2.55469 20.641 2.55469 19.9441 2.55469 18.5502V7.84794C2.55469 6.45404 2.55469 5.75708 2.82596 5.22468C3.06458 4.75637 3.44533 4.37561 3.91364 4.137C4.44605 3.86572 5.143 3.86572 6.53691 3.86572H7.03469C9.82251 3.86572 11.2164 3.86572 12.2812 4.40827C13.2178 4.8855 13.9794 5.64701 14.4566 6.58364C14.9991 7.64844 14.9991 9.04235 14.9991 11.8302M14.9991 26.2657V11.8302M14.9991 26.2657L15.1236 26.079C15.9881 24.7823 16.4203 24.134 16.9914 23.6646C17.4969 23.2491 18.0794 22.9373 18.7056 22.7472C19.4129 22.5324 20.1921 22.5324 21.7505 22.5324H23.4614C24.8553 22.5324 25.5522 22.5324 26.0846 22.2611C26.5529 22.0225 26.9337 21.6417 27.1723 21.1734C27.4436 20.641 27.4436 19.9441 27.4436 18.5502V7.84794C27.4436 6.45404 27.4436 5.75708 27.1723 5.22468C26.9337 4.75637 26.5529 4.37561 26.0846 4.137C25.5522 3.86572 24.8553 3.86572 23.4614 3.86572H22.9636C20.1758 3.86572 18.7819 3.86572 17.717 4.40827C16.7804 4.8855 16.0189 5.64701 15.5417 6.58364C14.9991 7.64844 14.9991 9.04235 14.9991 11.8302" stroke="#48A75C" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                      <div>
                        <h3>SMART PROGRESS TRACKING</h3>
                        <p>
                          Monitor your improvement across all vocabulary categories, dialogue types, and PTE question formats. See exactly where you need to focus for each exam.
                        </p>
                      </div>
                    </li>
                    <li className="list6">
                      <span className="list-counting">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.28802 12.577V20.0575C6.28802 20.5042 6.28802 20.7276 6.35604 20.9248C6.41618 21.0991 6.51434 21.258 6.64341 21.3897C6.78936 21.5388 6.98914 21.6386 7.38868 21.8384L14.1087 25.1984C14.4352 25.3617 14.5984 25.4433 14.7697 25.4754C14.9213 25.5039 15.0769 25.5039 15.2286 25.4754C15.3998 25.4433 15.5631 25.3617 15.8896 25.1984L22.6096 21.8384C23.0091 21.6386 23.2089 21.5388 23.3549 21.3897C23.4839 21.258 23.5821 21.0991 23.6422 20.9248C23.7102 20.7276 23.7102 20.5042 23.7102 20.0575V12.577M2.55469 10.7103L14.5539 4.71069C14.7172 4.62907 14.7988 4.58826 14.8844 4.57219C14.9602 4.55797 15.038 4.55797 15.1139 4.57219C15.1995 4.58826 15.2811 4.62907 15.4444 4.71069L27.4436 10.7103L15.4444 16.7099C15.2811 16.7915 15.1995 16.8324 15.1139 16.8484C15.038 16.8626 14.9602 16.8626 14.8844 16.8484C14.7988 16.8324 14.7172 16.7915 14.5539 16.7099L2.55469 10.7103Z" stroke="#0286FF" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                      <div>
                        <h3>EXPERT-DESIGNED CONTENT</h3>
                        <p>
                          Every feature, dialogue, vocabulary list, and PTE template is crafted by certified professionals who understand both exams inside out.
                        </p>
                      </div>
                    </li>
                    <li className="list7">
                      <span className="list-counting">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.1991 12.5768C26.1991 12.5768 23.704 9.17728 21.677 7.14887C19.65 5.12046 16.8489 3.86572 13.7547 3.86572C7.5691 3.86572 2.55469 8.88013 2.55469 15.0657C2.55469 21.2513 7.5691 26.2657 13.7547 26.2657C18.8608 26.2657 23.1688 22.8488 24.5169 18.1768M26.1991 12.5768V5.11017M26.1991 12.5768H18.7325" stroke="#FFB02C" strokeWidth="1.86667" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      </span>
                      <div>
                        <h3>REGULAR UPDATES</h3>
                        <p>
                          Content is continuously updated based on recent exam patterns and feedback from successful students for both NAATI CCL and PTE.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

         <div className="all-language-section language-support ap-bottom-line">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center mb-md-0 fw-700">
                THE BOTTOM LINE
                <br />
                <span className="wpl-badge gold-badge text-white">
                  YOUR SUCCESS <br className="d-block d-md-none" /> IS MOBILE
                </span>
              </h2>
            </div>        
            <div className="all-language-content">                     
              <div className="all-lang-card">
                <img
                  src="/images/web-new-images/naati-app-img-01.png"
                  alt="Register Now"
                />
                <p className="mt-4">
                  Cracking NAATI CCL and achieving high PTE scores isn't rocket science, but it does require smart, consistent preparation.
                  <br />
                  <br />
                  We understand the life-changing value of those 5 NAATI CCL points for Australian permanent residency and the global opportunities that come with strong PTE scores. That's why we've created the most comprehensive, convenient, and effective language exam preparation apps available.
                </p>
              </div>
              <div className="all-lang-card ap-bottom-line-card">
                <div className="icon-wrapper">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 12.1406L10.5 15.1406L16.5 9.14062M22 12.1406C22 17.6635 17.5228 22.1406 12 22.1406C6.47715 22.1406 2 17.6635 2 12.1406C2 6.61778 6.47715 2.14062 12 2.14062C17.5228 2.14062 22 6.61778 22 12.1406Z" stroke="#94C23C" strokeOpacity="0.98" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h2 className="title">
                  NO MORE EXCUSES
                </h2>
                <ul>
                  <li><p><span className="circle"></span> Busy schedule? Practice on your commute</p></li>
                  <li><p><span className="circle"></span> Missed a class? Access the same materials instantly</p></li>
                  <li><p><span className="circle"></span>Need quick review? Everything's <br /> in your pocket</p></li>
                  <li><p><span className="circle"></span>Multiple exams to prepare for? Switch between NAATI CCL and PTE seamlessly</p></li>
                  <li><p><span className="circle"></span>Exam tomorrow? Last-minute packages have you covered</p></li>
                </ul>
              </div> 
            </div>        
            <div className="text-center">
              <Link to="/auth/register" className="primary-btn dark-border">
                FIND YOUR PREPARATION PATH
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="pte-campus about-campus ap-your-success">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 text-center">
                <h2 className="primary-heading">
                  READY TO SECURE
                   <br />
                  <span className="wpl-badge text-white mb-4">
                    YOUR SUCCESS?
                  </span>
                </h2>
              </div>
              <div className="col-lg-6">
                <div className="pte-campus-list">
                  <img
                    src="/images/web-new-images/emojis/rocket-icon.png"
                    alt="Register Now"
                  />
                  <p className="sub-title fw-300">
                  <br />
                    Don't let a busy lifestyle delay your Australian permanent residency dreams or global opportunities.</p>
                  <br />
                  <p className="sub-title fw-500">Download the Language Academy apps today and join thousands of successful students who've earned their goals through smart, flexible preparation.</p>
                </div>
              </div>
            </div>
            <div className="downlaodnow-row">             
              <div className="downlaodnow-img">
                <h2 className="downlaodnow-badge">PTE CORE</h2>
                <img
                  src="/images/web-new-images/welcome-img-01.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-img card2">
                <h2 className="downlaodnow-badge">NAATI CCL</h2>
                <img
                  src="/images/web-new-images/welcome-img.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-third-col">
                <h3 className="downlaodnow-title">Available!</h3>
                <div className="downlaodnow-btns">
                  <a href="#" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a href="#" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
                <Link to="/auth/register" className="primary-btn dark-border">
                DOWNLOAD OUR APPS TODAY
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>                
              </div>
            </div>
          </div>
        </div>






        <Footer />
      </React.Fragment>
    );
  }
}

export default NaatiAppLp;
